import { MoneyBox } from '@apply/components';
import { formatCurrencyOrUndefined } from '@apply/ui';
import { IBudgetFixFlip } from '@apply/api/src/api/ApplyApi';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetFixFlipField } from '../../../../../queries/useBudgetFixFlipField';

interface ElectricalProps {
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const Electrical: React.FC<ElectricalProps> = ({ required = false, propertyGuid, isReview = false }) => {
    const [electrical, set_electrical] = useBudgetFixFlipField<number>(
        propertyGuid,
        (b) => (b.values?.['Major Systems']?.['Electrical']?.[1] as number) ?? 0,
        (b, v) => ({ ...b, values: { ...b.values, 'Major Systems': { ...b.values?.['Major Systems'], 'Electrical': [b.values?.['Major Systems']?.['Electrical']?.[0] ?? '', v] as [string, number] } } })
    );
    const label = 'Electrical (except fixtures)';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(electrical)}
                />
            ) : (
                <MoneyBox
                    id={'electrical'}
                    allowNegative={false}
                    value={electrical}
                    onChange={(value) => set_electrical(value)}
                    required={required}
                    label={label}
                />
            )}
        </>
    );
};
